import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BaseReport  {
    _originalTypeClassName = "zERP.BO.BaseReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BaseReport.translate = translateService;
}
this.From = null;
this.To = null;
this.PrintDate = null;
this.Level = null;
this.IncludeTempEntries = false;
this.IncludeAdjustingEntries = false;
this.IncludeZeroEntries = false;
this.BaseReportKey = null;
this._key = this.BaseReportKey = 0; 
}

static translate: TranslateService;
_key: any;
From:any;
To:any;
PrintDate:any;
Level:any;
IncludeTempEntries:any;
IncludeAdjustingEntries:any;
IncludeZeroEntries:any;
FiscalPeriod:any;
Ledger:any;
AccountFrom:any;
AccountTo:any;
Period:any;
BusinessEntity:any;
AccountCategory:any;
AccountingJournal:any;
private _BaseReportKey:any;
get BaseReportKey(): any {
    return this._BaseReportKey;
  }
set BaseReportKey(value: any) {
    this._BaseReportKey = value;
    this._key = value;
  }
static setFiscalPeriod = ($this, value) => {
var oldValue = $this.FiscalPeriod;
$this.FiscalPeriod = value;
if (value != null) {
}
}
static setLedger = ($this, value) => {
var oldValue = $this.Ledger;
$this.Ledger = value;
if (value != null) {
}
}
static setAccountFrom = ($this, value) => {
var oldValue = $this.AccountFrom;
$this.AccountFrom = value;
if (value != null) {
}
}
static setAccountTo = ($this, value) => {
var oldValue = $this.AccountTo;
$this.AccountTo = value;
if (value != null) {
}
}
static setPeriod = ($this, value) => {
var oldValue = $this.Period;
$this.Period = value;
if (value != null) {
}
}
static setBusinessEntity = ($this, value) => {
var oldValue = $this.BusinessEntity;
$this.BusinessEntity = value;
if (value != null) {
}
}
static setAccountCategory = ($this, value) => {
var oldValue = $this.AccountCategory;
$this.AccountCategory = value;
if (value != null) {
}
}
static setAccountingJournal = ($this, value) => {
var oldValue = $this.AccountingJournal;
$this.AccountingJournal = value;
if (value != null) {
}
}

static PrepareTransactions($this: any, accounts: any,allDetails: any,levelToInclude: any): any{let balances = new window['Map']();
let childAccounts = new window['Map']();
let watch = new System.Diagnostics.Stopwatch();
watch.start();
for (let _iacc = 0; _iacc < (accounts?.linq?.where((a) => CLMS.Framework.Number.NotEqual(() => a.AccountSign, () => 3))?.toArray() == null ? 0 : accounts?.linq?.where((a) => CLMS.Framework.Number.NotEqual(() => a.AccountSign, () => 3))?.toArray().length); _iacc++) {let acc = accounts?.linq?.where((a) => CLMS.Framework.Number.NotEqual(() => a.AccountSign, () => 3))?.toArray()[_iacc];let balance = new Domain.AccountBalance();balance.Account = acc.ChartOfAccountID;let data = allDetails?.linq?.where((d) => CLMS.Framework.Number.Equal(() => d.Account, () => acc.TAccount))?.toArray();balance.Credit = (data?.linq?.any() ? data?.linq?.sum((a) => a.Credit) : 0);balance.Debit = (data?.linq?.any() ? data?.linq?.sum((a) => a.Debit) : 0);if ((CLMS.Framework.Number.Equal(() => levelToInclude, () => null) || CLMS.Framework.Number.Equal(() => levelToInclude, () => 0)) || CLMS.Framework.Number.GreaterThanOrEqual(() => levelToInclude, () => acc.Level)) {balances.set(acc.ChartOfAccountID, balance);}let parent = acc.ParentChartOfAccount;if (CLMS.Framework.Number.NotEqual(() => parent, () => null) && CLMS.Framework.Number.GreaterThan(() => parent, () => 0)) {if (!(childAccounts.has(parent))) {let children = [];childAccounts.set(parent, children);}childAccounts.get(Joove.Common.safeNumber(parent) + Joove.Common.safeNumber(0))?.add(balance);}}
console.warn(" ---- loop 1: " + Joove.Common.safeNumber(watch.elapsedMilliseconds));
watch.restart();
for (let _iacc = 0; _iacc < (accounts?.linq?.orderByDescending((a) => a.Level)?.toArray()?.linq?.where((a) => CLMS.Framework.Number.Equal(() => a.AccountSign, () => 3))?.toArray() == null ? 0 : accounts?.linq?.orderByDescending((a) => a.Level)?.toArray()?.linq?.where((a) => CLMS.Framework.Number.Equal(() => a.AccountSign, () => 3))?.toArray().length); _iacc++) {let acc = accounts?.linq?.orderByDescending((a) => a.Level)?.toArray()?.linq?.where((a) => CLMS.Framework.Number.Equal(() => a.AccountSign, () => 3))?.toArray()[_iacc];let balance = new Domain.AccountBalance();balance.Account = acc.ChartOfAccountID;let children = (childAccounts.has(acc.ChartOfAccountID) ? childAccounts.get(acc.ChartOfAccountID) : null);balance.Credit = (children != null && children?.linq?.any() ? children?.linq?.sum((a) => a?.Credit) : 0);balance.Debit = (children != null && children?.linq?.any() ? children?.linq?.sum((a) => a?.Debit) : 0);if ((CLMS.Framework.Number.Equal(() => levelToInclude, () => null) || CLMS.Framework.Number.Equal(() => levelToInclude, () => 0)) || CLMS.Framework.Number.GreaterThanOrEqual(() => levelToInclude, () => acc.Level)) {balances.set(acc.ChartOfAccountID, balance);}let parent = acc.ParentChartOfAccount;if (CLMS.Framework.Number.NotEqual(() => parent, () => null) && CLMS.Framework.Number.GreaterThan(() => parent, () => 0)) {if (!(childAccounts.has(parent))) {let childrenAccs = [];childAccounts.set(parent, childrenAccs);}childAccounts.get(Joove.Common.safeNumber(parent) + Joove.Common.safeNumber(0))?.add(balance);}}
console.warn(" ---- loop 2: " + Joove.Common.safeNumber(watch.elapsedMilliseconds));
watch.stop();
return balances;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BaseReportKey == null || $this.BaseReportKey == 0;
            }


}